module.exports = __webpack_public_path__ + "7ba5418771ffcd8113d65c21664e43f1.svg";